
import FormDialog from "../../helpers/FormDialog";

export const LeadershipEdit = ({
    onSuccess,
    setOpen,
    open,
    resourceId,
    setValue0,
    value,
}) => {
    return (
        <FormDialog
            maxWidth={"md"}
            open={open > 0}
            onSuccess={onSuccess}
            setOpen={setOpen}
            url={open === 1 ? "/api/resource/reference/:resourceId" : `/api/resource/leadership-relative/update/${resourceId}`}
            title={open === 1 ? "Add Relative in Leadership" : " Relative in Leadership Position"}
            fields={[
                {
                    name: "leadershipPosition",
                    label: "Do you have any relative in a leadership position?",
                    type: "radio",
                    required: true,
                    values: [
                        { label: "Yes", value: "yes" },
                        { label: "No", value: "no" },
                    ],
                    value: value["leadershipPosition"],
                    setValue: (val) => setValue0("leadershipPosition", val),
                },
                ...(value["leadershipPosition"] === "yes"
                    ? [
                        {
                            name: "leaderName",
                            label: "Name",
                            type: "text",
                            value: value["leaderName"],
                            setValue: (val) => setValue0("leaderName", val),
                        },
                        {
                            name: "leaderRelationship",
                            label: "Relationship",
                            type: "text",
                            value: value["leaderRelationship"],
                            setValue: (val) => setValue0("leaderRelationship", val),
                        },
                        {
                            name: "position",
                            label: "Position",
                            type: "text",
                            value: value["position"],
                            setValue: (val) => setValue0("position", val),
                        },
                    ]
                    : []),
                {
                    name: "isAbroad",
                    label: "Do you have a relative in leadership living abroad?",
                    type: "radio",
                    values: [
                        { label: "Yes", value: "yes" },
                        { label: "No", value: "no" },
                    ],
                    value: value["isAbroad"],
                    required: true,
                    setValue: (val) => setValue0("isAbroad", val),
                },
                ...(value["isAbroad"] === "yes"
                    ? [
                        {
                            name: "abroadName",
                            label: "Name",
                            type: "text",
                            value: value["abroadName"],
                            setValue: (val) => setValue0("abroadName", val),
                        },
                        {
                            name: "abroadRelationship",
                            label: "Relationship",
                            type: "text",
                            value: value["abroadRelationship"],
                            setValue: (val) => setValue0("abroadRelationship", val),
                        },
                    ]
                    : []),
            ]}
        />
    );
};